<script setup>
import { ref, watch, computed, onMounted } from "vue";
import {
  Chart,
  BarElement,
  PointElement,
  BarController,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend
} from "chart.js";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  xTitle: {
    type: String,
    default: ''
  },
  yTitle: {
    type: String,
    default: ''
  },
  showLegend: {
    type: Boolean,
    default: false
  }
});

const root = ref(null);
let chart = null;

Chart.register(
  BarElement,
  PointElement,
  BarController,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend
);

onMounted(() => {
  chart = new Chart(root.value, {
    type: "bar",
    data: props.data,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          display: true,
          beginAtZero: true,
          title: {
            display: !!props.yTitle,
            text: props.yTitle,
            font: { size: 11, weight: 'bold' }
          },
          grid: {
            color: 'rgba(226, 232, 240, 0.6)'
          }
        },
        x: {
          display: true,
          title: {
            display: !!props.xTitle,
            text: props.xTitle,
            font: { size: 11, weight: 'bold' }
          },
          ticks: {
            maxRotation: 45,
            minRotation: 0,
            font: { size: 10 }
          },
          grid: {
            color: 'rgba(226, 232, 240, 0.4)'
          }
        },
      },
      plugins: {
        legend: {
          display: props.showLegend,
          position: 'top',
        },
        tooltip: {
          padding: 10,
          cornerRadius: 8
        }
      },
    },
  });
});

const chartData = computed(() => props.data);

watch(chartData, (newData) => {
  if (chart) {
    chart.data = newData;
    chart.update();
  }
});
</script>

<template>
  <canvas ref="root" />
</template>
